var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "linked-app-wrapper" },
      _vm._l(_vm.sortedApplications, function (application, index) {
        return _c(
          "linked-application-item",
          _vm._b(
            {
              key: application.applicationId,
              staticClass: "my-1",
              class: !_vm.last(index) ? "mb-2 pb-2" : "",
              on: {
                "duplicate-modal-opened": function ($event) {
                  return _vm.setDuplicateModalData(application.applicationId)
                },
                save: _vm.handleSave,
                "copy-application": _vm.handleCopyApplication,
              },
            },
            "linked-application-item",
            Object.assign({}, application, {
              clientProfileId: _vm.clientProfileId,
            }),
            false
          )
        )
      }),
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "sticky-controls column-divider-top" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 text-center" },
          [
            _vm.hasApplications
              ? _c(
                  "a",
                  {
                    staticClass:
                      "clickable text-primary bold add-client additional-app font-sm",
                    class: { disabled: _vm.isViewOnly },
                    on: { click: _vm.handleCreate },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "application.actions.createAdditionalApplication"
                        )
                      )
                    ),
                  ]
                )
              : [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "client-profile.messages.clientWithNoApplications"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm add-client",
                      attrs: { disabled: _vm.isViewOnly },
                      on: { click: _vm.handleCreate },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("application.actions.createApplication")
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-2" }, [
        _c(
          "div",
          {
            staticClass: "col-12 text-center",
            class: { disabled: _vm.unlinking },
          },
          [
            _c(
              "inline-prompt",
              {
                ref: "unlinkPrompt",
                staticClass: "bold text-gray clickable",
                attrs: {
                  "action-type": "delete",
                  "confirmation-text": _vm.$t(
                    "client-profile.actions.confirmUnlinkAllApplication"
                  ),
                },
                on: { accept: _vm.unlinkApplications },
                scopedSlots: _vm._u([
                  {
                    key: "preConfirmationContent",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "text-gray mb-2" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "client-profile.messages.unlinkApplication.0"
                                )
                              ) +
                              "\n              "
                          ),
                          _c("span", { staticClass: "bold" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t(
                                    "client-profile.messages.unlinkApplication.1"
                                  )
                                )
                            ),
                          ]),
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "client-profile.messages.unlinkApplication.2"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-row justify-content-center align-items-center pt-1 pb-2",
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "clickable text-danger bold font-sm" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.unlinking
                              ? _vm.$t("client-profile.actions.unlinking") +
                                  "..."
                              : _vm.$t(
                                  "client-profile.actions.unlinkAllApplications"
                                )
                          )
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }